import postError from './helpers/postError'

window.onerror = function handleError(msg, src, lineNo, colNo, error) {
    console.log(error);
    return postError(msg, src, lineNo, colNo, error);
}